
import splitSmartly from "split-smartly";

const TAG_REGEX = RegExp('</?([^>]*)>', 'ig');
function textToSimple(text) {
  let simpleText = text;
  simpleText = simpleText.replace(TAG_REGEX, function (match, p1) {
    return ['i', 'u', 'b'].includes(p1.toLowerCase()) ? match : '';
  });
  const lines = simpleText.split('\\n');
  const newLines = [];
  for (const line of lines) {
    if (line.startsWith('&lrm;')) {
      newLines.push('\u202a' + line.slice(5) + '\u202c');
    } else if (line.startsWith('&rlm;')) {
      newLines.push('\u202b' + line.slice(5) + '\u202c');
    } else {
      newLines.push(line);
    }
  }
  simpleText = newLines.join('\\n');
  return simpleText;
}

const splitToWords = (sentence) => {
  sentence = textToSimple(sentence)
  let sep = "|||||";
  let words = sentence
    .replace(/[.,،\/#!?؟$%\^&\*;:{}=\-_`~()]/g, " ")
    .replace("\n", " ")
    .split(" ")
    .filter((w) => w.trim().length > 0)
    .map((w) =>
      w
        .split("'")
        .filter((ch) => ch.length > 0)
        .join("'")
    )
    .sort(function (a, b) {
      return b.length - a.length;
    });
  let counter = 0;

  let obj = {};
  let sepArr = [];
  words.forEach((w) => {
    obj[sep + counter + sep] = w;
    sepArr.push(sep + counter + sep);
    sentence = sentence.replace(w, sep + counter++ + sep);
  });
  let res = splitSmartly(sentence, sepArr, {
    includeSeparatorMode: "SEPARATELY",
  });
  let allWords = res.map((w) => obj[w] || w);
  return { allWords, words };
};

const psPlayer = (words, subWordLearningStyles, userWordsDifficultyLevel, subWordCEFRStyles, cferWordsLevel) => {
  try {
    let seconds = []
    if (subWordLearningStyles["ps_on"]) {
      let indexs = []
      words.forEach((word) => {
        let getIndex = userWordsDifficultyLevel["words"].indexOf(word.toLowerCase())
        if (getIndex >= 0) indexs.push(getIndex)
      });
      indexs.forEach((idx) => {
        if (subWordLearningStyles[`ps_${userWordsDifficultyLevel["levels"][idx]}`] > 0)
          seconds.push(subWordLearningStyles[`ps_${userWordsDifficultyLevel["levels"][idx]}`])
      })
    }
    if (subWordCEFRStyles["ps_on"]) {
      let indexs = []
      words.forEach((word) => {
        let getIndex = cferWordsLevel["words"].indexOf(word.toLowerCase())
        if (getIndex >= 0) indexs.push(getIndex)
      });
      indexs.forEach((idx) => {
        if (subWordCEFRStyles[`ps_${cferWordsLevel["levels"][idx]}`] > 0)
          seconds.push(subWordCEFRStyles[`ps_${cferWordsLevel["levels"][idx]}`])
      })
    }
    if (seconds.length > 0) return (Math.max(...seconds))
    else return 0
  } catch (error) {
    console.error("Error in psPlayer")
    return 0
  }
};

const rpPlayer = (words, subWordLearningStyles, userWordsDifficultyLevel, subWordCEFRStyles, cferWordsLevel) => {
  try {
    let repeats = []
    if (subWordLearningStyles["rp_on"]) {
      let indexs = []
      words.forEach((word) => {
        let getIndex = userWordsDifficultyLevel["words"].indexOf(word.toLowerCase())
        if (getIndex >= 0) indexs.push(getIndex)
      });
      indexs.forEach((idx) => {
        if (subWordLearningStyles[`rp_${userWordsDifficultyLevel["levels"][idx]}`] > 0)
          repeats.push(subWordLearningStyles[`rp_${userWordsDifficultyLevel["levels"][idx]}`])
      })
    }
    if (subWordCEFRStyles["rp_on"]) {
      let indexs = []
      words.forEach((word) => {
        let getIndex = cferWordsLevel["words"].indexOf(word.toLowerCase())
        if (getIndex >= 0) indexs.push(getIndex)
      });
      indexs.forEach((idx) => {
        if (subWordCEFRStyles[`rp_${cferWordsLevel["levels"][idx]}`] > 0)
          repeats.push(subWordCEFRStyles[`rp_${cferWordsLevel["levels"][idx]}`])
      })
    }
    if (repeats.length > 0) {
      let rpt = Math.max(...repeats)
      return (rpt == 1 ? 1 : rpt + 1)
    }
    else return 0
  } catch (error) {
    console.error("Error in rpPlayer")
    return 0
  }
};

export { textToSimple, splitToWords, rpPlayer, psPlayer }